module.exports = __webpack_public_path__ + "assets/img/card_SG.16c2e874.svg";